import { AnnouncementCreate_announcementCreate_errors } from "@saleor/announcements/types/AnnouncementCreate";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { useCreateAnnouncementValidation } from "@saleor/utils/validators/announcements";
import { hasNoError } from "@saleor/utils/validators/sales";
import { RawDraftContentState } from "draft-js";
import Moment from "moment";
import React from "react";
import { useIntl } from "react-intl";

import AnnouncementContent from "../AnnouncementContent/AnnouncementContent";
import AnnouncementImage from "../AnnouncementImage";
import AnnouncementInfo from "../AnnouncementInfo";

export interface AnnouncementFormData {
  content: RawDraftContentState;
  endDate: string;
  image: string;
  startDate: string;
  title: string;
}

export interface AnnouncementCreatePageProps {
  errors: AnnouncementCreate_announcementCreate_errors[];
  onBack: () => void;
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  onSubmit(data: AnnouncementFormData, image: File);
}

const AnnouncementCreatePage: React.FC<AnnouncementCreatePageProps> = props => {
  const { onBack, disabled, saveButtonBarState, onSubmit, errors } = props;
  const intl = useIntl();

  const [imageToUpload, setImageToUpload] = React.useState(null);

  const [validator, setValidator] = React.useState({
    content: null,
    endDate: null,
    startDate: null,
    title: null
  });

  const initialForm: AnnouncementFormData = {
    content: null,
    endDate: null,
    image: null,
    startDate: Moment(new Date())
      .add(1, "d")
      .format("YYYY-MM-DD"),
    title: ""
  };

  const handleSubmit = event => {
    const validate = useCreateAnnouncementValidation(event);
    setValidator(validate);
    if (hasNoError(validate)) {
      onSubmit(event, imageToUpload);
    }
  };

  const breadcrumbDirectory = [
    {
      name: "Announcements",
      url: "/announcements"
    },
    {
      name: "Create Announcement"
    }
  ];

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ data, change, hasChanged, submit }) => (
        <Container>
          <PageBreadcrumbNavigation items={breadcrumbDirectory} />
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}
          >
            <PageBackNavigation onBack={onBack} />
            <PageHeader
              title={intl.formatMessage({
                defaultMessage: "Create Announcement",
                description: "page header"
              })}
            />
          </div>
          <div>
            <AnnouncementInfo
              errors={errors}
              data={data}
              onChange={change}
              disabled={false}
              localError={validator}
            />
            <CardSpacer />
            <AnnouncementImage
              data={data}
              onChange={change}
              onImageUpload={file => setImageToUpload(file)}
            />
            <CardSpacer />
            <AnnouncementContent
              errors={errors}
              onChange={change}
              disabled={false}
              localError={validator}
            />
          </div>
          {/* </Grid> */}
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            onCancel={onBack}
            onSave={submit}
            state={saveButtonBarState}
          />
        </Container>
      )}
    </Form>
  );
};

export default AnnouncementCreatePage;
